import React from "react";

function TextMessage({ data }) {
  return <p>{data.message}</p>;
}

export default TextMessage;
